module.exports = __webpack_public_path__ + "img/img-a15aea46.d5088e04.png";